interface Skill {
	name: string;
}

interface SkillLevel {
	level: number;
}

export const getSkillNameAndLevel = (skill: Skill, skillLevel?: SkillLevel): string => {
	return `${skill.name} - ${skillLevel?.level || '?'}`;
};
